import { TitleWinner } from "views/photographer/views/winners/custom.style";

export const languageES = {
  agegate: {
    title: ' ',
    description: (
      <>
        <img className="w-full" src={`${AZURE_BASE_URL}/agegate.webp`} alt="#CARTAENBLANCO" />
        <p className="agegate__description">Ingrese su fecha de nacimiento para empezar</p>
      </>
    ),
    politics1: <></>,
    politics2: <>
      Al confirmar, aceptas la <a href="/privacy-politics" className="underline">Política de privacidad</a>, <a href="/terms-and-conditions" className="underline">Términos y Condiciones</a> y <a href="/cookies" className="underline">Uso de cookies</a> de este sitio web. Este sitio web utiliza cookies. Para obtener más información, lee nuestra <a href="/privacy-politics" className="underline">Política de privacidad</a> y <a href="/cookies" className="underline">Uso de cookies</a>.
    </>
  },
  signup: {
    title: 'Bienvenido',
    description: 'Ahora eres parte del equipo. Revisa tus correos para comenzar a registrar tus latas para completar la colección. Consigue las 26 latas de Amstel Ultra y descubre los mensajes de Rafa Nadal.'
  },
  start: {
    signup: 'Regístrese con correo',
    signin: 'Éntrele con correo',
    social: 'ÉNTRELE CON:',
    title: {
      html: <div className="w-full flex-1"><img src={`${AZURE_BASE_URL}/fondo-inicial.webp`} className="w-full" alt="background" /></div>
    }
  },
  email: {
    recovery: 'Le enviamos un mail con las instrucciones para resetear su contraseña. Revise sus correos para poder volver a ingresar.',
    send: '¿No recibió ningún correo? ',
    title: "¡Bienvenido, name!",
    description: "SUBA SU FOTO Y GANE"
  },
  mail: {
    title: "¡Bienvenido, name!",
    description: "SUBA SU FOTO Y GANE"
  },
  home: {
    title: <span className="font-bold">¿QUÉ QUIERE HACER?</span>,
    description: '¡Complete sus datos!',
    popup: {
      two: {
        mobile: `${AZURE_BASE_URL}/popup-2-mobile.webp`,
        desktop: `${AZURE_BASE_URL}/popup-2-desktop.webp`,
        'desktop-1500': `${AZURE_BASE_URL}/popup-2-desktop-1500.webp`
      },
      six: {
        mobile: `${AZURE_BASE_URL}/popup-6-mobile.webp`,
        desktop: `${AZURE_BASE_URL}/popup-6-desktop.webp`,
        'desktop-1500': `${AZURE_BASE_URL}/popup-6-desktop-1500.webp`
      },
    }
  },
  update: {
    street: {
      subtitle: 'Si es correcto, complete los últimos datos y dele siguiente'
    }
  },
  profile: {
    form: {
      information: {
        firstname: {
          label: '¿CÓMO SE LLAMA?',
          placeholder: 'Ponga su nombre aquí'
        },
        lastname: {
          placeholder: 'Ponga su apellido aquí',
        },
        nickname: {
          label: '¿APODO?',
          placeholder: '¿Como le gusta que le digan?'
        },
        gender: {
          label: '¿CÓMO SE IDENTIFICA?'
        }
      }
    },
    information: 'DATOS PERSONALES',
    address: 'DIRECCIÓN',
    contact: 'CONTACTO',
    button: 'VAYA A SUS FOTOS'
  },
  config: {
    prizes: '/photographer/start?isYou=true'
  },
  congrats: {
    range: {
      title: "NUEVO LOGRO DESBLOQUEADO",
      description: <></>,
      description2: <>Felicitaciones, has desbloqueado nuevos <br /> premios y obtienes más chances de ganar.</>
    }
  },
  endroute: {
    title: <>¡Lo sentimos! <br /> Esto es solo para compas mayores de edad.</>,
    description: 'Regrese cuando sea más grande.'
  },
  album: {
    title: 'FOTOS CARTA BLANCA',
    states: {
      progress: "ACTUALES",
      completed: "PASADOS"
    },
    winners: {
      notFound: {
        title: <>
          <TitleWinner className='text-center'>Aun no hay ganadores</TitleWinner>
          <img src={`${AZURE_BASE_URL}/winners-not-found.webp`} alt="ranking" className="w-36" />
        </>
      }
    }
  }
}